import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {INVOICE_TYPE_V, HEAD_TYPE_V} from '@constants/index'
import {deepClone} from '@utils/index'

class InvoiceStore extends StoreExt {
    @observable loading: boolean = false
    @observable filterFlag: boolean = false // 筛选flag
    @observable deviceList: any = [] // 设备列表
    @observable invoicePayList: any = [] // 可开票列表
    @observable selectNum: number = 0 // 选中的数量
    @observable checkAllPageFlag: boolean = false // 是否本页全选
    @observable checkAllTypeFlag: boolean = false // 是否全部全选
    @observable activeDevice: string = '-1' // 当前查询的设备id，-1表示所有设备
    @observable invoiceType: string = '0' // 发票类型
    @observable headType: string = '0' // 抬头类型
    @observable invoiceHistory: any = [] // 开票历史列表
    @observable invoiceDetails: any = {} // 开票详情
    @observable multiple: any // 申请开票查询总额
    @observable invoiceFee: number = 0 // 订单金额
    @observable queryAllOrderId: any // 全部全选时查询获取的订单id集合

    @observable pageSize: number = 10 // 每页长度
    @observable current: number = 1 // 当前页
    @observable total?: number = 0 // 数据总量
    @observable simId?: any // 设备id
    @observable lock: boolean = false

    @action
    setLock = (flag) => {
        this.lock = flag
    }

    @action
    setCurrent = () => {
        this.current += 1
    }
    @action
    resetInvoicePayList = () => {
        runInAction(() => {
            this.invoicePayList = []
        })
    }

    @action
    resetPage = () => {
        runInAction(() => {
            this.current = 1
            this.total = 0
            this.lock = false
        })
    }

    @action
    resetForm = () => {
        runInAction(() => {
            this.filterFlag = false
            this.checkAllPageFlag = false
            this.checkAllTypeFlag = false
        })
    }

    @action
    resetList = () => {
        runInAction(() => {
            this.invoiceHistory = []
            this.invoiceDetails = {}
            this.invoiceType = '0'
            this.headType = '0'
            this.multiple = ''
        })
        sessionStorage.removeItem('checkedOrderId')
        sessionStorage.removeItem('checkedAllType')
        sessionStorage.removeItem('activeDevice')
    }

    // 获取设备列表
    @action
    getDeviceList = async (param) => {
        runInAction(() => this.loading = true)
        try {
            const res = await this.api.getDeviceList(param)
            runInAction(() => {
                this.loading = false
                this.deviceList = res
            })
        } catch (error) {
            console.log(error)
        }
    }

    // 切换设备
    @action
    switchDevice = (id) => {
        this.resetPage()
        runInAction(() => {
            this.activeDevice = id
        })
    }

    // 获取可开票订单列表
    @action
    getInvoicePayList = async (id: string, type?: string) => {
        runInAction(() => {
            this.simId = id
        })
        if (this.lock) {
            return
        }
        try {
            const param = {
                simId: this.simId,
                current: this.current,
                pageSize: this.pageSize
            }
            const res = await this.api.getInvoicePayList(param)
            runInAction(() => {
                this.loading = false

                if (this.checkAllTypeFlag && this.current !== 1) {
                    // 当 全部全选 获取分页数据时，将新获得的订单数据默认选中
                    res.list.map((item, index) => {
                        item.checked = true
                    })
                } else {
                    // 当 单独勾选&本页全选 获取分页数据时，为每条数据增加checked属性
                    res.list.map((item, index) => {
                        item.checked = false
                    })
                }

                if ((this.current === 1 && deepClone(this.invoicePayList).length === 0) || type === 'switch') {
                    // 当获取的数据是第一页时
                    this.invoicePayList = res.list
                    this.total = res.total
                    this.selectNum = 0
                    this.resetForm()
                } else if (this.current !== 1) {
                    this.invoicePayList = this.invoicePayList.concat(res.list)
                }
                this.setLock(res.list.length < 10)
                this.total = res.total
            })
        } catch (error) {
        }
    }

    // 切换筛选结构状态
    @action
    switchFilterFun = () => {
        runInAction(() => {
            this.filterFlag = !this.filterFlag
        })
    }

    // 单独设备的选中&移除操作
    @action
    checkInvoice = (index) => {
        runInAction(() => {
            this.selectNum = 0
            this.invoicePayList[index].checked = !this.invoicePayList[index].checked
            this.invoicePayList.map((item, index) => {
                if (item.checked) {
                    this.selectNum += 1
                }
            })
            this.checkAllTypeFlag = false
            this.checkAllPageFlag = false
        })
    }

    // 本页全选
    @action
    checkeAllPage = () => {
        if (!this.checkAllPageFlag) {
            runInAction(() => {
                this.selectNum = 0
                this.checkAllPageFlag = true
                this.checkAllTypeFlag = false
                this.invoicePayList.map((item, index) => {
                    item.checked = true
                    if (item.checked) {
                        this.selectNum += 1
                    }
                })
            })
        } else {
            runInAction(() => {
                this.selectNum = 0
                this.checkAllPageFlag = false
                this.checkAllTypeFlag = false
                this.invoicePayList.map((item, index) => {
                    item.checked = false
                })
            })
        }
    }

    // 全部全选
    @action
    checkAllType = () => {
        if (!this.checkAllTypeFlag) {
            runInAction(() => {
                this.selectNum = this.total
                this.checkAllTypeFlag = true
                this.checkAllPageFlag = true
                this.invoicePayList.map((item, index) => {
                    item.checked = true
                })
            })
        } else {
            runInAction(() => {
                this.selectNum = 0
                this.checkAllPageFlag = false
                this.checkAllTypeFlag = false
                this.invoicePayList.map((item, index) => {
                    item.checked = false
                })
            })
        }
    }

    // 可开票订单下一步
    @action
    goNext = () => {
        if (this.selectNum > 0 || this.checkAllTypeFlag) {
            let checkedOrderId = ''
            this.invoicePayList.map((item, index) => {
                if (item.checked) {
                    if (!checkedOrderId) {
                        checkedOrderId = item.orderId
                    } else {
                        checkedOrderId += (',' + item.orderId)
                    }
                }
            })
            this.goToPath(`/app/mine/invoice/invoice-detail/${checkedOrderId}/${this.checkAllTypeFlag ? '1' : '0'}/${this.activeDevice}`)
        } else {
            this.$toast.info('请先选中需要开票的订单')
        }
    }

    // 查询多个订单总开票金额
    @action
    getInvoiceOrderTotalFee = async (param) => {
        try {
            const res = await this.api.getInvoiceOrderTotalFee(param)
            runInAction(() => {
                this.multiple = res
                this.invoiceFee = res.totalFeeSum
                this.queryAllOrderId = res.orderIds
            })
        } catch (error) {
            console.log(error)
        }
    }

    // 切换发票类型
    @action
    changeInvoiceType = (type) => {
        runInAction(() => {
            this.invoiceType = type
            if (type === INVOICE_TYPE_V.P_INVOICE) {
                this.headType = HEAD_TYPE_V.ENTERPRICE
            }
        })
    }

    // 切换抬头类型
    @action
    changeHeadType = (type) => {
        runInAction(() => {
            this.headType = type
        })
    }

    // 提交开票申请
    @action
    submitForm = async (param) => {
        try {
            let res = null
            if (!param.invoiceId) {
                res = await this.api.submitApply(param)
            } else {
                delete param.updateTime
                delete param.createTime
                res = await this.api.modifyInvoiceApply(param)
            }
            if (res.code == '200') {
                runInAction(() => {
                    this.resetList()
                    this.goToPath('/app/mine/invoice/invoice-apply')
                })
            } else {
                this.$toast.info('申请失败，请稍后重新申请')
            }
        } catch (error) {
            console.log(error)
        }
    }

    // 获取开票历史列表
    @action
    getInvoiceHistory = async () => {
        if (this.lock) { return }
        try {
            const param = {
                current: this.current,
                pageSize: this.pageSize
            }
            const res = await this.api.getInvoiceHistory(param)
            runInAction(() => {
                this.invoiceHistory = this.current === 1 ? res.list : [...this.invoiceHistory, ...res.list]
                this.setLock(res.list.length < 10)
            })
        } catch (error) {
        }
    }

    // 下拉刷新
    @action
    onDown = (type) => {
        runInAction(() => {
            this.current = 1
            if (type === 'history') {
                this.getInvoiceHistory()
            } else if (type === 'invoice') {
                this.getInvoicePayList(this.simId)
            }
        })
    }

    // 上拉加载
    @action
    onUp = (type) => {
        runInAction(() => {
            if (this.current <= Math.ceil(this.total / this.pageSize)) {
                if (type === 'history') {
                    this.getInvoiceHistory()
                } else if (type === 'invoice') {
                    this.getInvoicePayList(this.simId)
                }
            } else {
                this.$toast.info('没有更多订单了')
            }
        })
    }

    // 获取开票详情
    @action
    getInvoiceDetails = async (param) => {
        try {
            const res = await this.api.getInvoiceDetails(param)
            runInAction(() => {
                this.invoiceDetails = {
                    ...res,
                    updateTimeStr: res.updateTime
                }
                this.invoiceFee = res.invoiceFee
                this.invoiceType = res.invoiceType
                this.headType = res.headType
            })
        } catch (error) {
            console.log(error)
        }
    }

    // 撤销申请
    @action
    cancelApply = async (param) => {
        try {
            const res = await this.api.cancelInvoiceApply(param)
            console.log(res)
            runInAction(() => {
                if (res.code === '200') {
                    this.goToPath('/app/mine/invoice/invoice-history')
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    // 输入赋值
    @action
    setValue = (value, type) => {
        switch (type) {
            case 'headName':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    headName: value
                }
                break;
            case 'taxNo':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    taxNo: value
                }
                break;
            case 'address':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    address: value
                }
                break;
            case 'bankName':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    bankName: value
                }
                break;
            case 'bankNo':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    bankNo: value
                }
                break;
            case 'bizAddress':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    bizAddress: value
                }
                break;
            case 'bizPhone':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    bizPhone: value
                }
                break;
            case 'contact':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    contact: value
                }
                break;
            case 'contactPhone':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    contactPhone: value
                }
                break;
            case 'updateTimeStr':
                this.invoiceDetails = {
                    ...this.invoiceDetails,
                    updateTimeStr: value
                }
                break;
        }
    }
}

const invoiceStore = new InvoiceStore()
export {
    invoiceStore,
    InvoiceStore
}
